import { render, staticRenderFns } from "./TableAdjustOdds.vue?vue&type=template&id=5bfe0590&scoped=true&"
import script from "./TableAdjustOdds.vue?vue&type=script&lang=js&"
export * from "./TableAdjustOdds.vue?vue&type=script&lang=js&"
import style0 from "./TableAdjustOdds.vue?vue&type=style&index=0&id=5bfe0590&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfe0590",
  null
  
)

export default component.exports